import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/vuex/store'
import echarts from 'echarts'
import './bus'
import '@/utils/common'
import '@/utils/chart'
import '@/assets/css/common.css' // 公共样式
import '@/assets/less/element.less'
import { getToken } from '@/utils/auth'
// $ ssh-agent bash
// $ ssh-add.exe ~/.ssh/zq.rsa

import {
  Breadcrumb,
  BreadcrumbItem,
  Loading,
  Message,
  MessageBox,
  Container,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Input,
  Switch,
  DatePicker,
  Tree,
  Cascader,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
  Select,
  Option,
  Table,
  TableColumn,
  Button,
  Pagination,
  Timeline,
  TimelineItem,
  Popover,
  Upload
} from 'element-ui'
Vue.use(Loading).use(Container).use(Aside).use(Main).use(Menu).use(Submenu).use(MenuItemGroup).use(MenuItem)
  .use(Tabs).use(TabPane).use(Table).use(TableColumn).use(Button).use(Pagination)
  .use(Form).use(Cascader).use(FormItem).use(Input).use(Switch).use(DatePicker).use(Tree).use(CheckboxGroup).use(Checkbox).use(RadioGroup).use(Radio).use(Select).use(Option).use(Upload)
  .use(Timeline).use(TimelineItem).use(Popover).use(Breadcrumb).use(BreadcrumbItem)
Vue.prototype.$message = Message
// 该写法解决线上部署报错_MessageBox is not defined
const msgbox = MessageBox
const { alert, confirm } = msgbox
Vue.prototype.$msgbox = msgbox
Vue.prototype.$confirm = confirm
Vue.prototype.$alert = alert

Vue.prototype.$echarts = echarts

// 判断当前环境
Vue.prototype.os = (() => {
  const ua = navigator.userAgent
  const isWindowsPhone = /(?:Windows Phone)/.test(ua)
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  const isAndroid = /(?:Android)/.test(ua)
  const isFireFox = /(?:Firefox)/.test(ua)
  const isChrome = /(?:Chrome|CriOS)/.test(ua)
  const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
  const isMac = /macintosh|mac os x/i.test(ua)
  const isIOS = /(?:iPhone|iPad|PlayBook)/.test(ua)
  const isWx = /micromessenger/.test(ua.toLowerCase())
  const isWxwork = /wxwork/.test(ua.toLowerCase())
  const isPc = !isIOS && !isAndroid && !isSymbian
  return {
    tablet: isTablet,
    isIOS: isIOS,
    android: isAndroid,
    isWx: isWx,
    isWxwork: !!(isWx && isWxwork),
    isMac: isMac,
    isChrome: isChrome,
    isPc: isPc
  }
})()

Vue.config.productionTip = false
if (module.hot) {
  module.hot.accept()
}

router.beforeEach((to, from, next) => {
  // 判断后台模块是否有权限，如果没有则直接到首页
  const token = getToken()
  // 页面权限验证
  if (to.meta.requireNoAuth) {
    return next()
  } else if (!token) {
    return next('/login')
  } else {
    const userMenuAuth = store.state.userInfo.menuAuth || [] // 获取当前用户所有模块权限
    const authId = to.meta.authId // 当前模块权限id
    // token存在而且需要验证token的页面，通过用户菜单权限来判断页面是否存在
    if (to.meta.childrenAuthId) {
      const childrenAuthId = to.meta.childrenAuthId // 当前模块权限id
      const hasAuthPage = childrenAuthId.filter(pageItem => {
        const isAuto = userMenuAuth.find(item => item.code === pageItem.authId)
        return isAuto
      })
      // console.log(hasAuthPage)
      return next(hasAuthPage.length ? hasAuthPage[0].path : '/403')
    } else if (authId) {
      const isAuto = userMenuAuth.find(item => item.code === authId)
      if (!isAuto) return next('/403')
    }
  }
  next()
})

router.afterEach(route => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
